<template>
    <div ref="countryContent" class="area-country-content" :class="{ active: isOpenList}" data-country="">
        <div class="area-country-name" @click="onOpenListClick()">
            <span>{{group}}</span>
            <img src="https://resource.rcclchina.com.cn/Home/new/dest-arrow.png" />
        </div>
        <ul class="country">
            <li v-if="groupDests.length > 1"  class="destination-area-item search-form-list-item search-form-list-item-all"
                data-cnvalue="全部" data-filtercode="全部" data-key="DestinationCode" data-cruise="row" data-country=""
                @click="onDestinationAllClick(group)"
                :class="{ active: isSelectedAll(group), disable: isDisableAll(group)}"
                >
                <img class="selected" src="https://resource.rcclchina.com.cn/homePage/mobile/mb-gou.png" alt="" />
                <span>全部</span>
                <img v-if="cruiseType=='hp'" class="flag" :src="groupDests[0].countryFlag" :style="getCountryFlagStyle(groupDests[0].filterCode)" />
            </li>

            <li v-for="(groupDest, index) in groupDests" :key="index" 
                class="destination-area-item search-form-list-item"
                :class="{ active: isSelected(groupDest.filterCode), disable: isDisable(groupDest.filterCode) }"
                @click="onDestinationClick(groupDest)"
                >
                <img class="selected" src="https://resource.rcclchina.com.cn/homePage/mobile/mb-gou.png" alt="" />
                <span>{{groupDest.title}}</span>
                <img v-if="cruiseType=='row'" class="flag" :src="groupDest.countryFlag" :style="getCountryFlagStyle(groupDest.filterCode)" />
            </li>
        </ul>
    </div>

</template>

<script>
export default {
    name: 'DestinationList',
    components: {
    
    },
    props: {
        cruiseType: {
            type: String,
            default: function() {
                return "hp"
            }
        },
        subCategory: {
            type: String,
            default: function() {
                return ""
            }
        },
        group: {
            type: String,
            default: function() {
                return ""
            }
        },
        groupDests: {
            type: Array,
            default: function() {
                return []
            }
        },
        destinations: {
            type: Array,
            default: function() {
                return []
            }
        },
        index: {
            type: Number,
            default: function() {
                return 0
            }
        },
        groupCount: {
            type: Number,
            default: function() {
                return 0
            }
        },
        initOpenList: {
            type: Boolean,
            default: () => {
                return false
            }
        },
        onDestinationListOpen: {
            type: Function
        }
    },
    data () {
        return {
            selectDestinations: [],
            selectAllDestinationGroups: [],
            isOpenList: false
        }
    },
    beforeMount () {
        this.isOpenList = this.initOpenList
    },
    updated () {
    },
    methods: {
         getCountryFlagStyle (filterCode) {
            if (filterCode == "LAB" || filterCode == "PCC")
            {
                return { "width": "16px" }
            }
            else if (filterCode == "")
            {
                return { "width": "18px" }
            }
            return {}
        },
        onDestinationClick (destination) {
            let code = destination.filterCode
            if (this.isDisable(code)) {
                return
            }
            let name = destination.title
            let group = destination.cruiseFilterGroupName
            let isExists = this.selectDestinations.some(item=> item.code == code)
            const cruiseType = this.cruiseType
            const data = { 
                cruiseType,
                key: 'destinations',
                values: [{ code, name }]
            }
            if (isExists) {
                this.selectDestinations = this.selectDestinations.filter(item => !(item.code == code))
                this.$store.dispatch('REMOVE_CRUISE_FILTERS', data)

                if (this.isSelectedAll(group)) {
                    this.selectAllDestinationGroups = this.selectAllDestinationGroups.filter(item=>!(item == group))
                }

            } else {
                this.selectDestinations.push({ code, name, group })
                this.$store.dispatch('SET_CRUISE_FILTERS', data)

                // 全选逻辑
                if (this.checkDestinationAllSelected(group)) {
                    if (!this.isSelectedAll(group)) {
                        this.selectAllDestinationGroups.push(group)
                    }
                }
            }
        },
        onDestinationAllClick (destinationGroup) {
            const cruiseType = this.cruiseType
            // 反选
            if (this.isSelectedAll(destinationGroup)) {
                this.selectAllDestinationGroups = this.selectAllDestinationGroups.filter(item=>!(item == destinationGroup))
                // 删除该group下所有选择
                const needRemoveDests = this.selectDestinations.filter(item => item.group == destinationGroup)
                this.selectDestinations = this.selectDestinations.filter(item => !(item.group == destinationGroup))
                const data = {
                    cruiseType,
                    key: 'destinations',
                    values: needRemoveDests
                }
                this.$store.dispatch('REMOVE_CRUISE_FILTERS', data)
            } else {
                if (this.isDisableAll(destinationGroup)) {
                    return
                }
                const destinations = this.destinations.filter(item=>item.cruiseFilterGroupName == destinationGroup)
                let needAddDests = []
                destinations.forEach((destination) => {
                    if (!this.selectDestinations.some(item => item.code == destination.filterCode)) {
                        let code = destination.filterCode
                        if (!this.isDisable(code)) {
                            let name = destination.title
                            let group = destination.cruiseFilterGroupName
                            needAddDests.push({ code, name, group })
                            this.selectDestinations.push({ code, name, group })
                        }
                    }
                })
                this.selectAllDestinationGroups.push(destinationGroup)
                const data = {
                    cruiseType,
                    key: 'destinations',
                    values: needAddDests
                }
                this.$store.dispatch('SET_CRUISE_FILTERS', data)
            }
        },
        checkDestinationAllSelected (desitnationGroup) {
            let departures = this.getDestinationByGroup(desitnationGroup)
            let selectedCount = this.selectDestinations.filter(item => item.group == desitnationGroup).length
            return departures.length == selectedCount
        },
        isSelected (code) {
            return this.selectDestinations.some(item=> item.code == code)
        },
        isSelectedAll (desitnationGroup) {
            return this.selectAllDestinationGroups.includes(desitnationGroup)
        },
        getDestinationByGroup (desitnationGroup) {
            return this.destinations.filter(item => item.cruiseFilterGroupName == desitnationGroup)
        },
        isDisable (code) {
            const availableItems = this.$store.state.cruise.filterResponse[this.cruiseType].destinations
            return !availableItems.includes(code)
        },
        isDisableAll (group) {
            const availableItems = this.$store.state.cruise.filterResponse[this.cruiseType].destinations
            let destinationCodes = this.getDestinationByGroup(group).map(item=>item.filterCode)
            return !availableItems.some(item=> destinationCodes.includes(item))
        },
        onOpenListClick () {
            if (!this.isOpenList) {
                this.onDestinationListOpen(this.$refs.countryContent.offsetTop)
            }
            this.isOpenList = !this.isOpenList
        }
    },
    computed: {
        storeDesinations () {
            return this.$store.state.cruise.filterRequest[this.cruiseType].destinations
        }
    },
    watch: {
        storeDesinations (newOne) {
            if (newOne.length == 0 && this.selectDestinations.length > 0) {
                this.selectDestinations = []
                this.selectAllDestinationGroups = []
            }
        },
        initOpenList (newOne) {
            if (newOne != this.isOpenList) {
                this.isOpenList = newOne
            }
        }
    }
}
</script>
